/**
 * Guard for Steps 2–4: if Step 1 never saved a draft, bounce to Step 1.
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../utils/createRoutes';
import {
  hasValidCreateDraft,
  peekCreateFlowExit,
} from '../utils/createSessionFlowStorage';

export function RequireCreateDraft({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const ok = hasValidCreateDraft();

  useEffect(() => {
    if (hasValidCreateDraft()) return;
    const exit = peekCreateFlowExit();
    // After successful create, draft is cleared on purpose — don't bounce to Step 1.
    if (exit === 'listing') {
      navigate(ROUTES.viewSessions, { replace: true });
      return;
    }
    if (exit === 'suppress') return;
    navigate(ROUTES.createSession, { replace: true });
  }, [navigate]);

  if (!ok) return null;
  return <>{children}</>;
}
